// extracted by mini-css-extract-plugin
export default {"input":"Input_input__lOV-R","small":"Input_small__nWuyV Input_input__lOV-R","medium":"Input_medium__yIwZK Input_input__lOV-R","error":"Input_error__mkfDF"};